module.exports = __webpack_public_path__ + "img/ZJ5248.a35e6a42.png";